exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2ABq6{position:relative;margin:0 auto;padding:0 15px;max-width:1000px}._2ABq6 h1,._2ABq6 h2,._2ABq6 h3{text-align:center}._2ABq6 h1{margin-bottom:50px}._2ABq6 h2{margin-bottom:0}._2ABq6 h3{margin-top:10px}@media (min-width:992px){._1wdVL{min-height:calc(100vh - 50px)}}._4VQaZ{margin:50px 0 75px}._3rEyO{padding-top:25px;padding-bottom:25px;background:#ccf8ef}", ""]);

// exports
exports.locals = {
	"container": "_2ABq6",
	"section": "_1wdVL",
	"contentImage": "_4VQaZ",
	"services": "_3rEyO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/routes/home/Home.scss
// module id = 692
// module chunks = 2